export default "__VITE_ASSET__Da9D$JPq__"